/**
 * @format
 * @flow strict-local
 */
// DEPENDENCIES

import React, {
	useEffect,
	useState
} from "react";
import {
	connect
} from "react-redux";

import {} from "./Account.styled";

import i18nHelper from "../../helpers/i18n";
import routerHelper from "../../helpers/router";
import storeHelper from "../../helpers/store";
import utilsHelper from "../../helpers/utils";

//import useApi from "../../hooks/api";

import i18n from "../../i18n";

// INIT

/**
 * mapStateToProps - ...
 * 
 * @param {object} state ...
 */
const mapStateToProps = (state) => {
	return {
		...state
	};
};

// COMPONENT

const Account = (props) => {
	/*
	const {
		fetchApi
	} = useApi();
	*/	
	// Lifecycle

	useEffect(
		() => {
	    }, 
		[]
	);

	// Events

	// Misc

	// Render

	const render = () => {
		return (
			<div>
				Account
			</div>
		);
	};

	return render();
};

// EXPORT

export default connect(mapStateToProps)(Account);
